let data = [
        {
            id: "1",
            title: "Nest Js",
            percent: 60,
            icon: "nestjs"
        },
        {
            id: "2",
            title: "Mongo DB (Database)",
            percent: 60,
            icon: "mongodb"
        },
        {
            id: "3",
            title: "Express Js",
            percent: 75,
            icon: "express"
        },
        {
            id: "4",
            title: "React Js",
            percent: 83,
            icon: "react"
        },
        {
            id: "5",
            title: "Material Ui",
            percent: 95,
            icon: "materialui"
        },
        {
            id: "6",
            title: "Charts Js",
            percent: 75,
            icon: "chart"
        },
        {
            id: "7",
            title: "React Native",
            percent: 75,
            icon: "react"
        },
        {
            id: "8",
            title: "FireBase (Database)",
            percent: 90,
            icon: "firebase"
        },
        {
            id: "9",
            title: "Redux ToolKit",
            percent: 75,
            icon: "redux"
        },
        {
            id: "10",
            title: "Postman",
            percent: 80,
            icon: "postman"
        },
        {
            id: "11",
            title: "Github",
            percent: 75,
            icon: "github"
        },
        {
            id: "12",
            title: "Cloudinary",
            percent: 83,
            icon: "cloudinary"
        },
        {
            id: "13",
            title: "Python",
            percent: 65,
            icon: "py"
        },
        {
            id: "14",
            title: "React BootStrap",
            percent: 79,
            icon: "bootstrap"
        },
        {
            id: "15",
            title: "JavaScript",
            percent: 80,
            icon: "js"
        },
        {
            id: "16",
            title: "CSS",
            percent: 85,
            icon: "css"
        },
    ]


    export default data